import React, { useEffect, useState } from 'react'
import { StyleSheet, Text, TextInput, TouchableOpacity, View } from 'react-native'
import theme from '../../../theme'
import { SelectList } from 'react-native-dropdown-select-list'
import { Feather } from '@expo/vector-icons'
import { getLocation } from '../appBar/context/LocationContext'
import styles from './AddStoresStyles'
import { ScrollView } from 'react-native-gesture-handler'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { useNavigation } from '@react-navigation/native'
import { request_add_pos } from '../../services/schedule.services'
import { getConection } from '../appBar/context/HeaderContext'
import { fetchAuthSession } from 'aws-amplify/auth'
import { Loader } from '../customUtils/Components/Loader'
import { AddStoresModel } from './models/AddStoresModel'
import { schedulesServices } from '../../../database/schedules.database'
import { validateConnectionNetwork } from '../../utils/functions.utils'
import { checkStoreLocalByName, cleanupLocalStores } from '../../../db-sqlite/repositories/schedule.repository'

export const AddStores = ({ route }) => {
    const { schedule_id, distributor_id } = route.params
    console.log('🚀 ~ AddStores ~ schedule_id:', schedule_id, distributor_id)
    const { userLat, userLng } = getLocation()
    const [fields, setAddPos] = useState(add_pos)
    const [name, setName] = useState('')
    const [code, setCode] = useState('')
    const [address, setAddress] = useState('')
    const [maximum_distance_for_checking, setMaximum_distance_for_checking] = useState('')
    const [cluster, setCluster] = useState('')
    const [area, setArea] = useState('')
    const [region, setRegion] = useState('')
    const [country, setCountry] = useState('')
    const [format, setFormat] = useState('')
    const [flag, setFlag] = useState('')
    const [department, setDepartment] = useState('')
    const [retailer, setRetailer] = useState('')
    const [isButtonEnabled, setIsButtonEnabled] = useState(false)
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const navigation = useNavigation()
    const { isConnected, hasInternet } = getConection()
    const { languageFile } = getLanguage()
    const [loading, setLoading] = useState(false)

    const getDataCreateStores = async () => {
        try {
            const data_create = await schedulesServices.getInfoCreateStores()
            if (data_create.areas) {
                setAddPos({
                    ...fields,
                    area: {
                        ...fields.area,
                        data: JSON.parse(data_create.areas),
                    },
                })
            }
        } catch (error) {
            console.error('🚀 ~ getDataCreateStores ~ error:', error)
        }
    }
    useEffect(() => {
        getDataCreateStores()
    }, [])

    const createStore = async () => {
        try {
            let add_store_service = null
            let storeExists = false
            if (loading) {
                return
            }
            setLoading(true)
            let fields = [
                { name: 'name', value: name ? name.toUpperCase() : '' },
                { name: 'code', value: code },
                { name: 'lat', value: userLat },
                { name: 'lng', value: userLng },
                { name: 'address', value: address },
                { name: 'maximum_distance_for_checking', value: maximum_distance_for_checking },
                { name: 'cluster', value: cluster },
                { name: 'area', value: area },
                { name: 'region', value: region },
                { name: 'country', value: country },
                { name: 'format', value: format },
                { name: 'flag', value: flag },
                { name: 'department', value: department },
                { name: 'retailer', value: retailer },
            ]
            let rta: any = {}
            for (let index = 0; index < fields.length; index++) {
                if (fields[index] != null && fields[index].value != '') {
                    rta = {
                        ...rta,
                        [fields[index].name]: fields[index].value,
                    }
                }
            }

            if (schedule_id) {
                rta = { ...rta, schedule_id: schedule_id }
            }
            if (distributor_id) {
                rta = { ...rta, distributor_id: distributor_id }
            }

            console.log('🚀 ~ createStore ~ rta:', JSON.stringify(rta))
            let storeIdCreated = null
            try {
                const response = await sendStore(rta)
                console.log('🚀 ~ createStore ~ response:', JSON.stringify(response))
                if (response && response.status == 1) {
                    //actualizo registros con este nuevo id
                    //schedule_adv
                    //checkin
                    //checkout
                    //formularios
                    if (response?.single?.message) {
                        const message = response.single.message || '';
                        if (message.toLowerCase().includes('repetido')) {
                            storeExists = true;
                            console.log('La tienda ya existe en el endpoint remoto.');
                        }
                    }

                    if (response.single.pos) {
                        storeIdCreated = response.single.pos._id
                        console.log('Nuevo storeID creado en online => ', storeIdCreated)
                    }
                }
            } catch (error) {
                console.error('🚀 ~ createStore ~ sendStore error:', error)
            }

            let add_store_local = null

            if (!storeExists) {
                
                let isExistLocal = await checkStoreLocalByName(schedule_id, rta.name)
                console.log('🚀 ~ createStore ~ isExistLocal:', isExistLocal)
                // validar si existe en local
                if (!isExistLocal) {

                    const data_create = await schedulesServices.getInfoCreateStores()
        
                    console.log('1🚀 ~ createStore ~ data_create:', data_create)
        
                    add_store_local = await schedulesServices.addStoreLocal(rta, data_create.forms)
        
                    console.log('2🚀 ~ createStore ~ add_store_local:', JSON.stringify(add_store_local))
                }
            }

            if (add_store_local && add_store_local.changes > 0) {
                add_store_service = { status: 1 }
                const storeIdLocal = add_store_local.storeId || null

                if (storeIdCreated && storeIdLocal) {

                    console.log('📡 ONLINE: Actualizando registros locales con ID del servidor')

                    // 1. Actualizar registros locales con el ID definitivo
                    await schedulesServices.updateStoreRecords(storeIdLocal, storeIdCreated)

                    // 2. Eliminar la tienda local inmediatamente (ya tenemos la definitiva)
                    await cleanupLocalStores(true, [storeIdLocal])

                    console.log(`✅ Tienda local ${storeIdLocal} eliminada, ahora usando ${storeIdCreated}`)
                } else if (storeIdLocal) {
                    console.log('📴 OFFLINE: Tienda creada localmente, se sincronizará después')
                }

            }

            if (add_store_service && add_store_service?.status == 1) {
                // si da ok llamar a la fn que envia local
                let image = require('../../../assets/stores/inactiveVespertino.png')
                let title = 'Tienda creada con éxito'
                let desc = 'Ahora puedes comenzar a realizar las encuestas planificadas para el día de hoy. ¡Todo está listo para que empieces!'
                let button = 'Aceptar'
                openBottomSheet(
                    <BottomSheetAlert
                        image={image}
                        title={title}
                        desc={desc}
                        button={button}
                        closeBottomSheet={() => {
                            closeBottomSheet(true)
                            navigation.goBack()
                        }}
                    />,
                )
                setLoading(false)
            } else {
                let image = require('../../../assets/stores/existingStore.png')
                let title = 'No es posible crear tienda'
                let desc =
                    'La tienda que estás intentando crear ya existe en tu agenda. Si tu tienda tiene el mismo nombre que una ya registrada, no podrás cargarla nuevamente. Asegúrate de verificar el nombre antes de continuar.'
                let button = 'Aceptar'
                openBottomSheet(<BottomSheetAlert image={image} title={title} desc={desc} button={button} closeBottomSheet={closeBottomSheet} />)
                setLoading(false)
            }
        } catch (error) {
            console.error('🚀 ~ createStore ~ error:', error)
        }
    }

    const sendStore = async (rta) => {
        try {
            const hasConnection = await validateConnectionNetwork()
            if (hasConnection) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                const data = {
                    authToken: authToken,
                    body: rta,
                }
                const res = await request_add_pos(data)
                console.log('165 -- 🚀 ~ sendStore ~ res:', res)
                return res
            }
        } catch (error) {
            console.error('168 -- 🚀 ~ sendStore ~ error:', error)
            throw error
        }
    }

    useEffect(() => {
        // Verificar si todos los campos requeridos están completos

        const allFieldsFilled =
            (!fields.name || !fields.name.visibility || name) &&
            (!fields.code || !fields.code.visibility || code) &&
            (!fields.address || !fields.address.visibility || address) &&
            (!fields.maximum_distance_for_checking || !fields.maximum_distance_for_checking.visibility || maximum_distance_for_checking) &&
            (!fields.cluster || !fields.cluster.visibility || cluster) &&
            (!fields.area || !fields.area.visibility || area) &&
            (!fields.region || !fields.region.visibility || region) &&
            (!fields.country || !fields.country.visibility || country) &&
            (!fields.format || !fields.format.visibility || format) &&
            (!fields.flag || !fields.flag.visibility || flag) &&
            (!fields.department || !fields.department.visibility || department) &&
            (!fields.retailer || !fields.retailer.visibility || retailer)

        setIsButtonEnabled(Boolean(allFieldsFilled))
    }, [name, code, address, maximum_distance_for_checking, cluster, area, region, country, format, flag, department, retailer])

    return (
        <View style={styles.container}>
            <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
                <View style={{ flexDirection: 'row', alignItems: 'baseline' }}>
                    <Text style={styles.title}>Estás creando una nueva tienda</Text>
                </View>
                <Text style={[styles.note, { paddingBottom: 12, paddingRight: 8 }]}>
                    Debes completar todos los campos obligatorios (*) para crear una nueva tienda
                </Text>
                {fields && (
                    <View>
                        {fields.name && fields.name.visibility && <AddStoreTextField item={fields.name} updateField={setName} />}
                        {fields.code && fields.code.visibility && <AddStoreTextField item={fields.code} updateField={setCode} />}
                        {fields.address && fields.address.visibility && <AddStoreTextField item={fields.address} updateField={setAddress} />}
                        {fields.maximum_distance_for_checking && fields.maximum_distance_for_checking.visibility && (
                            <AddStoreTextField item={fields.maximum_distance_for_checking} updateField={setMaximum_distance_for_checking} />
                        )}
                        {fields.cluster && fields.cluster.visibility && <AddStoreDropField item={fields.cluster} updateField={setCluster} />}
                        {fields.area && fields.area.visibility && <AddStoreDropField item={fields.area} updateField={setArea} />}
                        {fields.region && fields.region.visibility && <AddStoreTextField item={fields.region} updateField={setRegion} />}
                        {fields.country && fields.country.visibility && <AddStoreTextField item={fields.country} updateField={setCountry} />}
                        {fields.format && fields.format.visibility && <AddStoreDropField item={fields.format} updateField={setFormat} />}
                        {fields.flag && fields.flag.visibility && <AddStoreDropField item={fields.flag} updateField={setFlag} />}
                        {fields.department && fields.department.visibility && (
                            <AddStoreDropField item={fields.department} updateField={setDepartment} />
                        )}
                        {fields.retailer && fields.retailer.visibility && <AddStoreDropField item={fields.retailer} updateField={setRetailer} />}
                    </View>
                )}
                <View style={styles.buttonContainer}>
                    {!loading ? (
                        <TouchableOpacity
                            onPress={() => createStore()}
                            style={[styles.mainButton, { backgroundColor: isButtonEnabled ? theme.colors.colorPrimary : theme.colors.disabled }]}
                            disabled={!isButtonEnabled}
                        >
                            <Text style={[styles.mainButtonText, { color: isButtonEnabled ? 'white' : theme.colors.darkGray }]}>Crear tienda</Text>
                        </TouchableOpacity>
                    ) : (
                        <Loader />
                    )}
                </View>
            </ScrollView>
        </View>
    )
}

export const AddStoreTextField = ({ item, updateField }: { item: AddStoresModel; updateField: (text: string) => void }) => {
    const [text, setText] = useState('')
    const updateValue = (text: string) => {
        setText(text)
        updateField(text)
    }
    return (
        <View>
            {item.label && <Text style={styles.title}>{item.label ?? ''}*</Text>}
            <View style={styles.inputContainer}>
                <TextInput
                    style={styles.input}
                    placeholder={item.placeholder ?? ''}
                    placeholderTextColor={theme.colors.mediumGray}
                    value={text}
                    onChangeText={(text) => updateValue(text)}
                    keyboardType={item.type === 'number' ? 'number-pad' : 'default'}
                />
            </View>
        </View>
    )
}

export const AddStoreDropField = ({ item, updateField }: { item: AddStoresModel; updateField: (text: string) => void }) => {
    const [value, setValue] = useState()

    const options =
        item.data.map((option) => {
            return { key: option._id, value: option.name }
        }) ?? []

    const updateValue = (val: any) => {
        console.log('Valor recuperado', val)
        setValue(val)
        updateField(val)
    }

    return (
        <View>
            {item.label && <Text style={styles.title}>{item.label ?? ''}*</Text>}

            <SelectList
                placeholder={item.placeholder ?? ''}
                data={options ?? []}
                setSelected={(val) => updateValue(val)}
                save='key'
                search={false}
                arrowicon={<Feather name={'chevron-down'} size={22} color={theme.colors.colorPrimary} />}
                boxStyles={styles.inputdrop}
                dropdownStyles={styles.dropdown}
                dropdownTextStyles={styles.dropdownOptions}
                inputStyles={value ? styles.dropdownInputSelected : styles.dropdownInput}
            />
        </View>
    )
}

const add_pos = {
    name: {
        name: 'name',
        required: true,
        label: 'Nombre de la tienda',
        placeholder: 'Ingrese el nombre de la tienda',
        visibility: true,
        type: 'input',
    },
    code: {
        name: 'code',
        required: false,
        label: 'Código',
        placeholder: 'Ingrese el código de la tienda',
        visibility: false,
        type: 'input',
    },
    lat: {
        name: 'lat',
        required: true,
        label: 'Latitud',
        placeholder: 'Ingrese latitud de la tienda',
        visibility: false,
        type: 'input',
    },
    lng: {
        name: 'lng',
        required: true,
        label: 'Longitud',
        placeholder: 'Ingrese longitud de la tienda',
        visibility: false,
        type: 'input',
    },
    address: {
        name: 'address',
        required: false,
        label: 'Dirección',
        placeholder: 'Ingrese dirección de la tienda',
        visibility: false,
        type: 'input',
    },
    maximum_distance_for_checking: {
        name: 'maximum_distance_for_checking',
        required: false,
        label: 'Límite de distancia - Sin puntos o espacios',
        placeholder: '(Ejemplo: 200)',
        visibility: false,
        type: 'number',
    },
    cluster: {
        name: 'cluster',
        required: false,
        label: 'Cluster',
        placeholder: 'Ingrese cluster de la tienda',
        visibility: false,
        type: 'dropdown',
        data: [
            {
                _id: '64df775edeb91d0008bcee84',
                name: 'Querétaro',
            },
            {
                _id: '64df775edeb91d0008bcee7e',
                name: 'Monterrey',
            },
        ],
    },
    area: {
        name: 'area',
        required: false,
        label: 'Plaza',
        placeholder: 'Ingrese área de la tienda ',
        visibility: true,
        type: 'dropdown',
        data: [
            {
                _id: '653693945291916cdd629a79',
                name: 'Toluca',
            },
            {
                _id: '651ee8cf0de4cf000827951a',
                name: 'CDMX',
            },
        ],
    },
    region: {
        name: 'region',
        required: false,
        label: 'region',
        placeholder: 'Ingresa región de la tienda',
        visibility: false,
        type: 'input',
    },
    country: {
        name: 'country',
        required: false,
        label: 'País',
        placeholder: 'Ingrese país de la tienda',
        visibility: false,
        type: 'input',
    },
    format: {
        name: 'format',
        required: false,
        label: 'Formato',
        placeholder: 'Ingrese formato de la tienda',
        visibility: false,
        type: 'dropdown',
        data: [
            {
                _id: '0000110010',
                name: 'formato 1',
            },
            {
                _id: '000011001020349',
                name: 'formato 2',
            },
        ],
    },
    flag: {
        name: 'flag',
        required: false,
        label: 'Bandera',
        placeholder: 'Ingrese bandera de la tienda',
        visibility: false,
        type: 'dropdown',
        data: [
            {
                _id: '0000110010',
                name: 'flag 1',
            },
            {
                _id: '000011001020349',
                name: 'falg 2',
            },
        ],
    },
    department: {
        name: 'department',
        required: false,
        label: 'department',
        placeholder: 'Ingrese department de la tienda',
        visibility: false,
        type: 'dropdown',
        data: [
            {
                _id: '0000110010',
                name: 'dep 1',
            },
            {
                _id: '000011001020349',
                name: 'dep 2',
            },
        ],
    },
    retailer: {
        name: 'retailer',
        required: false,
        label: 'Retailer',
        placeholder: 'Ingrese retailer de la tienda',
        visibility: false,
        type: 'dropdown',
        data: [
            {
                _id: '0000110010',
                name: 'ret 1',
            },
            {
                _id: '000011001020349',
                name: 'ret 2',
            },
        ],
    },
}
